export default __webpack_public_path__ + "static/media/500.cb0dfbe4.png";